import { createSelector } from 'reselect'
import { getEntities, getInactivityAlarms as getInactivityAlarmsEntities } from './entities'
import { denormalize } from 'normalizr'
import * as schemas from '../../schemas'

export const getInactivityAlarmsRaw = createSelector(
  [getEntities, getInactivityAlarmsEntities],
  (entities, inactivityAlarms) => {
    inactivityAlarms = inactivityAlarms.map(a => {
      return a
    })
    return denormalize(inactivityAlarms, [schemas.inactivityAlarm], entities)
  }
)
